exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._ṔhotoPreview-photoPreview-28VKI figure{margin:10px;display:inline-block;cursor:pointer}._ṔhotoPreview-photoPreview-28VKI ._ṔhotoPreview-popover-2AArz{position:fixed;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;z-index:10;background:hsla(0,0%,76%,.53);top:0;left:0;right:0;bottom:0}._ṔhotoPreview-photoPreview-28VKI ._ṔhotoPreview-popover-2AArz span{position:absolute;color:#000;font-size:2em;font-weight:700}._ṔhotoPreview-photoPreview-28VKI ._ṔhotoPreview-popover-2AArz img{max-width:90vw;max-height:90vh;cursor:pointer;position:absolute}", ""]);

// exports
exports.locals = {
	"photoPreview": "_ṔhotoPreview-photoPreview-28VKI",
	"popover": "_ṔhotoPreview-popover-2AArz"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/ticket/components/ṔhotoPreview.less
// module id = 1782
// module chunks = 0